import { Box, Button, MenuItem, TextField } from "@mui/material";
import { cardSx, BRAND, BRAND_D, BRAND_L } from "./liveGridStyles";

/**
 * The page's ONE filter. A single Industry + Stock selection drives both the
 * stock dashboard and the model-ranking grid, which is why it lives above them
 * rather than inside either card.
 *
 * The two grids cover different populations — 1,551 researched stocks vs 268
 * scored securities — so a shared selection can legitimately fill one and empty
 * the other. Each grid says so itself rather than the option lists being trimmed
 * to the intersection, because trimming would make the ranked funds and ETFs
 * (which have no row in the research universe) unreachable by name, and
 * unreachable data is worse than a grid that says "no rows".
 */
export default function StockFilterBar({
  industries, stockOptions, industry, stock, onIndustry, onStock, onClear,
}) {
  return (
    <Box sx={{ ...cardSx, display: "flex", gap: 1.75, alignItems: "flex-end", flexWrap: "wrap", pt: 1.75, pb: 1.75 }}>
      <TextField
        select size="small" label="Industry" value={industry}
        onChange={(e) => onIndustry(e.target.value)}
        sx={{ minWidth: 220 }}
      >
        <MenuItem value="">All</MenuItem>
        {industries.map((i) => <MenuItem key={i} value={i}>{i}</MenuItem>)}
      </TextField>
      <TextField
        select size="small" label="Stock" value={stock}
        onChange={(e) => onStock(e.target.value)}
        sx={{ minWidth: 160 }}
      >
        <MenuItem value="">All</MenuItem>
        {stockOptions.map((s) => <MenuItem key={s} value={s}>{s}</MenuItem>)}
      </TextField>
      <Button
        size="small" variant="outlined" onClick={onClear}
        disabled={!industry && !stock}
        sx={{
          textTransform: "none", fontWeight: 600, borderRadius: "6px",
          color: "text.secondary", borderColor: "divider",
          "&:hover": { borderColor: BRAND, color: BRAND_D, backgroundColor: BRAND_L },
        }}
      >
        Clear
      </Button>
    </Box>
  );
}
